import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HttpService } from 'src/app/services';

@Component({
  selector: 'app-images-dialog',
  templateUrl: './images-dialog.component.html',
  styleUrls: ['./images-dialog.component.scss']
})
export class ImagesDialogComponent implements OnInit {
 
  hotel_Image;
  constructor(public http: HttpService,) { }

  ngOnInit(): void {
  this.hotelImage(); 
  }
 
hotelImage(){
  this.hotel_Image = JSON.parse(localStorage.getItem('property_detail'))
}

  hotelOptions: OwlOptions = {
    loop: true,
    autoplayHoverPause: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    autoplay: true,
    autoplaySpeed: 950,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 1
      }
    },
    nav: true,
  }
}